import { httpClient } from './httpClient';


export const uploadFile = async (url, file, extraFields) => {
	const data = new FormData();
	data.append('file', file);
	if (extraFields) {
		Object.entries(extraFields).forEach(([key, value]) => {
			if (value !== undefined && value !== null && value !== '') {
				data.append(key, value);
			}
		});
	}
	const response = await httpClient(url, {
		method: 'POST',
		body: data,
	});
	return response.json;
}
